import { Link } from 'react-router-dom';
import { useLayoutSlots } from '@/features/layout';
import { CopilotLauncher } from '@/features/copilot';

import { Breadcrumbs } from './Breadcrumbs';
import { GlobalSearch } from './GlobalSearch';
import styles from './Header.module.css';

function Header() {
  const { breadcrumbItems } = useLayoutSlots();

  return (
    <header className={styles.header}>
      <div className={styles.leftSection}>
        <Link to="/" className={styles.logo}>
          <img
            src="/assets/iCardio_Heart_only.svg"
            alt="iCardio"
            className={styles.logoImage}
          />
        </Link>
        <Breadcrumbs items={breadcrumbItems} />
      </div>

      <div className={styles.centerSection}>
        <GlobalSearch />
        <CopilotLauncher />
      </div>

      <div className={styles.rightSection}>
        <img
          src="/assets/icardio-logo.svg"
          alt="iCardio.ai"
          className={styles.wordmark}
        />
      </div>
    </header>
  );
}

export default Header;
